import React, { useEffect } from "react";
import { observer } from "mobx-react";
import WidgetGrid from "./WidgetGrid/WidgetGrid";
import WidgetCatalog from "./WidgetCatalog/WidgetCatalog";
import DashboardLoader from "./Widgets/DashboardLoader";
import dashboardV2Store from "./store/dashboardV2Store";
import widgetDataStore from "./store/widgetDataStore";
import DashboardState from "../mainState";


const DashboardV2 = observer(() => {
  const { activeDashboard = null, showWidgetCatalog = false, isLoadingDashboards = false } = dashboardV2Store;
  const { activeDateFilter = "", activeCustomRange = null } = widgetDataStore;

  useEffect(() => {
    dashboardV2Store.fetchDashboards();
    dashboardV2Store.fetchWidgetCatalog();
  }, []);

  // Custom-date-filter: also re-fetch when the custom range changes (activeDateFilter stays "custom",
  // so the range values themselves must be in the dependency list).
  useEffect(() => {
    if (activeDashboard?.widgets?.length) {
      widgetDataStore.fetchAllWidgetData(activeDashboard.widgets, activeDashboard.id);
    }
  }, [activeDashboard?.id, activeDateFilter, activeCustomRange?.fromDate, activeCustomRange?.toDate]);

  useEffect(() => {
    widgetDataStore.setMemberIds(DashboardState.memberId || []);
    if (activeDashboard?.widgets?.length) {
      widgetDataStore.fetchAllWidgetData(activeDashboard.widgets, activeDashboard.id);
    }
  }, [DashboardState.memberId]);

  return (
    <div className="dashboardV2">
      {isLoadingDashboards ? (
        <div className="widgetGridWrap">
          <DashboardLoader />
        </div>
      ) : activeDashboard ? (
        <>
          <WidgetGrid widgets={activeDashboard.widgets} />
          {showWidgetCatalog && <WidgetCatalog />}
        </>
      ) : (
        <div className="dashboardV2EmptyState">
          <p className="dashboardV2EmptyStateTitle">No dashboards yet</p>
          <p className="dashboardV2EmptyStateSubtitle">
            Click <strong>+</strong> to create your first dashboard
          </p>
        </div>
      )}
    </div>
  );
});

export default DashboardV2;
